/**
 * Version compatibility configuration.
 *
 * expectedApiVersion: the major.minor version this frontend is built for.
 * The check compares major.minor only — patch differences are tolerated.
 */
export const expectedApiVersion = '1.2';
